import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const GeoCity = () => {

    const [statesList, setStatesList] = useState<any[]>([]);
    const [districtsList, setDistrictsList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [stateId, setStateId] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [cityId, setCityId] = useState("");
    const [cityName, setCityName] = useState("");
    const [cityStatus, setCityStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchCity();
    }, [])

        async function fetchCity() {
            setIsLoading(true);
            const cityResponse = await func.listGeoCity();
            setCityList(Array.isArray(cityResponse) ? cityResponse : [])
            setIsLoading(false);
        }

    const filteredData = cityList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const stateNameRender = (rowData) => {
        return <span>{rowData.geographyName}</span>;
    };

    const districtNameRender = (rowData) => {
        return <span>{rowData.geoDistrictsName}</span>;
    };

    const cityNameRender = (rowData) => {
        return <span>{rowData.geoCityName}</span>;
    };

    const cityStatusRender = (rowData) => {
        return <span>{(rowData.geoCityStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCity(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const ctyId = rowData.geoCityId;
        return (
            <Link to="#" onClick={() => deleteCity(ctyId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newCity() {
        setIsEdit(false)
        setOpenModal(true)
        setStateId('')
        setDistrictId('')
        setCityName('')
        const stateResponse = await func.listGeoStates();
        setStatesList(Array.isArray(stateResponse) ? stateResponse : [])
    }

    async function editCity(rowData: { geoCityId: string | number; }) {
        const ctyId = rowData.geoCityId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.getGeoCity(ctyId);
        const stateResponse = await func.listGeoStates();
        setStatesList(Array.isArray(stateResponse) ? stateResponse : [])
        const distResponse = await func.listGeoDistrictByStateId(getDetails.geoDistrictsId);
        setDistrictsList(Array.isArray(distResponse) ? distResponse : [])
        setDistrictId(getDetails.geoDistrictsId)
        setCityId(getDetails.geoCityId)
        setStateId(getDetails.geographyId)
        setCityName(getDetails.geoCityName)
        setCityStatus(getDetails.geoCityStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCity();
            } else {
                if (districtId && cityName) {
                    const formData = new FormData();
                    // formData.append("geographyId", stateId);
                    formData.append("districtId", districtId);
                    formData.append("name", cityName);

                    const createCity = api.CreateGeoCity;
                    fetch(createCity, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // window.location.reload(); // 🔁 Reload only after OK is clicked
                                        setOpenModal(false);
                                        fetchCity();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updateCity() {
        const formData = new FormData();
        // formData.append("geographyId", stateId);
        formData.append("districtId", districtId);
        formData.append("name", cityName);
        formData.append("status", cityStatus);

        const updateCity = api.UpdateGeoCity + '/' + cityId;
        fetch(updateCity, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchCity();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteCity(ctyId: string) {
        const formData = new FormData();
        formData.append("status", '0');
        const deleteCity = api.DeleteGeoCity + '/' + ctyId;
        fetch(deleteCity, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchCity();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>City</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCity() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create City">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            {/* <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="geographyName"
                                                header="State Name"
                                                body={stateNameRender}
                                                className="table-inset-btn"
                                            ></Column> */}
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="districtName"
                                                header="District Name"
                                                body={districtNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="geoCityName"
                                                header="City Name"
                                                body={cityNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="geoCityStatus"
                                                header="City Status"
                                                body={cityStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} City</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                {/* <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">State Name</label>
                                        <Select
                                            value={statesList.find(state => state.geographyId === stateId) ? {
                                                value: stateId,
                                                label: statesList.find(state => state.geographyId === stateId).geographyName
                                            } : null}
                                            onChange={async (e) => {
                                                setStateId(e.value);
                                                const response = await func.listGeoDistrictByStateId(e.value);
                                                setDistrictsList(Array.isArray(response) ? response : [])
                                            }}
                                            required
                                            placeholder="Select State"
                                            options={statesList.map(role => ({
                                                value: role.geographyId,
                                                label: role.geographyName
                                            }))}>
                                        </Select>
                                    </div>
                                </div> */}
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">District Name</label>
                                        <Select
                                            value={districtsList.find(dist => dist.geoDistrictsId === districtId) ? {
                                                value: districtId,
                                                label: districtsList.find(dist => dist.geoDistrictsId === districtId).geoDistrictsName
                                            } : null}
                                            onChange={async (e) => {
                                                setDistrictId(e.value);
                                            }}
                                            required
                                            placeholder="Select District"
                                            options={districtsList.map(dist => ({
                                                value: dist.geoDistrictsId,
                                                label: dist.geoDistrictsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">City Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="cityname"
                                            placeholder="Enter City Name"
                                            required
                                            value={cityName}
                                            onChange={(e) => setCityName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={cityStatus === '1'}
                                                        id="geoCityStatus"
                                                        onChange={(e) => {
                                                            setCityStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal >
                )
            }
        </>
    )
}

export default GeoCity;